import { KText } from '@/ui-library/components/text';

export const HeaderCell = ({ title, ...props }) => {
  return (
    <KText variant="heading_3" textTransform="capitalize" {...props}>
      {title}
    </KText>
  );
};
